export default "__VITE_ASSET__BVdw8zSu__"